import {
  DatePicker,
  Grid,
  TextField,
  Box,
  CurrencyInput,
  Select,
  MenuItem,
  InputAdornment,
  Tooltip,
  Button,
} from "../../../../components";
import { formatDate, unformatPrice } from "../../../../utils";
import { isCampoBloqueado, isCampoPlaca } from "../../entities/campos-veiculo";

const botaoPlacaSx = {
  height: "35px",
  borderRadius: "20%",
  minWidth: "15px",
  boxShadow: "none",
};

const RenderizadorCamposValues = ({
  campos,
  onChangeValor,
  disabled = false,
  onBuscarPlaca,
  buscandoPlaca = false,
  lancamentoManual = false,
  onAlternarLancamentoManual,
}) => {
  const renderAcoesPlaca = () => (
    <InputAdornment position="end" sx={{ gap: 0.5 }}>
      {onBuscarPlaca && (
        <Tooltip title="Buscar por Placa" arrow placement="bottom">
          <Button
            variant="contained"
            disabled={disabled || buscandoPlaca || lancamentoManual}
            size="small"
            sx={botaoPlacaSx}
            onClick={onBuscarPlaca}
          >
            <i
              className="ph-bold ph-magnifying-glass"
              style={{ color: "#fff", fontSize: 15 }}
            />
          </Button>
        </Tooltip>
      )}
      {onAlternarLancamentoManual && (
        <Tooltip
          title={
            lancamentoManual
              ? "Voltar para a busca por placa"
              : "Lançar dados manualmente (sem busca por placa)"
          }
          arrow
          placement="bottom"
        >
          <Button
            variant="contained"
            disabled={disabled || buscandoPlaca}
            size="small"
            sx={
              lancamentoManual
                ? botaoPlacaSx
                : {
                    ...botaoPlacaSx,
                    backgroundColor: "#EDEEF0",
                    "&:hover": { backgroundColor: "#B6BABC" },
                  }
            }
            onClick={onAlternarLancamentoManual}
          >
            <i
              className="ph-bold ph-pencil-simple-line"
              style={{ color: lancamentoManual ? "#fff" : "#555", fontSize: 15 }}
            />
          </Button>
        </Tooltip>
      )}
    </InputAdornment>
  );

  const renderCampo = (campo) => {
    const baseProps = {
      name: campo.id.toString(),
      label: campo.label,
      disabled: disabled || (isCampoBloqueado(campo) && !lancamentoManual),
      sx: { mb: 1 },
      required: campo.obrigatoriedade,
      fullWidth: true,
      value: campo.value || (campo.type === "date" ? null : ""),
    };

    switch (campo.type) {
      case "string":
        return (
          <TextField
            {...baseProps}
            onChange={(event) => onChangeValor(campo.id, event.target.value?.toUpperCase())}
            InputProps={
              isCampoPlaca(campo) &&
              (onBuscarPlaca || onAlternarLancamentoManual)
                ? { endAdornment: renderAcoesPlaca() }
                : undefined
            }
          />
        );

      case "number":
        return (
          <TextField
            {...baseProps}
            type="number"
            onChange={(event) => onChangeValor(campo.id, event.target.value)}
          />
        );

      case "date":
        return (
          <DatePicker
            {...baseProps}
            format="dd/MM/yyyy"
            shrink
            onChange={(data) => {
              const isValidDate = (d) => d instanceof Date && !isNaN(d);
              if (isValidDate(data)) {
                onChangeValor(campo.id, formatDate.toSend(data));
              }
            }}
          />
        );

      case "money":
        return (
          <CurrencyInput
            {...baseProps}
            variant="outlined"
            margin="none"
            onBlur={(event) => {
              const valorFormatado = unformatPrice(event.target.value);
              onChangeValor(campo.id, valorFormatado);
            }}
          />
        );

      case "enum":
        return (
          <Select
            {...baseProps}
            onChange={(event) => onChangeValor(campo.id, event.target.value)}
          >
            {campo.values?.split(',').map((item, index) => {
              return (
                <MenuItem key={index} value={item}>
                  {item}
                </MenuItem>
              );
            })}
          </Select>
        );

      default:
        return <></>;
    }
  };

  return (
    <Grid container spacing={2} columns={15}>
      {campos.map((campo) => (
        <Grid item xs={3} key={campo.id}>
          <Box p={0} width="100%">
            {renderCampo(campo)}
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};

export default RenderizadorCamposValues;
